import { getFullName } from "./userUtils";
import { workKindLabel } from "./workKind";

export function cardAssigneesOf(post) {
  const list = post?.assignees || post?.Assignees;
  if (Array.isArray(list) && list.length) return list;
  const single = post?.assignee || post?.Assignee;
  return single ? [single] : [];
}

export function formatAssigneeNames(assignees) {
  const names = (assignees || []).map((a) => getFullName(a)).filter(Boolean);
  if (names.length === 0) return null;
  if (names.length === 1) return names[0];
  if (names.length === 2) return `${names[0]}, ${names[1]}`;
  return `${names[0]}, ${names[1]} +${names.length - 2}`;
}

export function cardAuthorUser(post) {
  const id =
    post?.user?.user_id ||
    post?.user?.userId ||
    post?.user_id ||
    post?.userId ||
    null;
  if (post?.user && typeof post.user === "object") {
    return { ...post.user, user_id: id || post.user.user_id };
  }
  return id ? { user_id: id } : null;
}

export function isIntakeAuthor(post, teamMemberIds) {
  if (!teamMemberIds || teamMemberIds.size === 0) return false;
  const id =
    post?.user?.user_id ||
    post?.user?.userId ||
    post?.user_id ||
    post?.userId ||
    null;
  if (!id) return false;
  return !teamMemberIds.has(String(id));
}

/**
 * Feed / thread byline parts for a kanban card.
 * Intake (author not on the team) uses "requested this {Kind}".
 */
export function cardAttributionParts(post, { teamMemberIds } = {}) {
  const kind = workKindLabel(post);
  const author = cardAuthorUser(post);
  const authorName = getFullName(author);
  const verb = isIntakeAuthor(post, teamMemberIds)
    ? `requested this ${kind}`
    : `created this ${kind}`;
  const teamName =
    post?.team?.name || post?.teamName || post?.team_name || null;
  const assigned = formatAssigneeNames(cardAssigneesOf(post));
  return { authorName, verb, teamName, assigned, author };
}
